import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-archives-graphboard-list',
    templateUrl: './archives-graphboard-list.component.html',
    styleUrls: ['./archives-graphboard-list.component.scss']
})
export class ArchivesGraphboardListComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }

}
